import * as Yup from "yup";

export const CopyCalendarTypesSchema = Yup.object()
  .shape({
    nonPrinting: Yup.boolean().required(),
    nonSms: Yup.boolean().required(),
    nonEmail: Yup.boolean().required(),
    nonEhf: Yup.boolean().required(),
  })
  .test(
    "at-least-one-type",
    "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_SELECT_AT_LEAST_ONE_COMMUNICATION_CHANNEL",
    (value: any) => {
      if (!value) return false;
      return (
        !!value.nonPrinting ||
        !!value.nonSms ||
        !!value.nonEmail ||
        !!value.nonEhf
      );
    },
  );

// Backwards-compatible export name (legacy misspelling).
// NOTE: This schema validates the UI "types" object used in Formik values.
export const CopyCalanderParamsSchema = CopyCalendarTypesSchema;

export const CopyCalendarValidationSchema = Yup.object().shape({
  copy: Yup.lazy((value: any) => {
    const shape: Record<string, any> = {};
    if (value && typeof value === "object") {
      Object.keys(value).forEach((k) => {
        shape[k] = Yup.object().shape({
          dateRange: Yup.mixed()
            .test(
              "required-range",
              "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD",
              (val: any) => {
                return Array.isArray(val) && !!val[0] && !!val[1];
              },
            )
            .required(
              "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD",
            ),
          reason: Yup.string()
            .trim()
            .required(
              "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD",
            ),
          types: CopyCalendarTypesSchema,
        });
      });
    }
    return Yup.object().shape(shape);
  }),
});
